import React from "react";
import loadable from "@loadable/component";
import { tw } from "@careinfo/tailwind";
const DebitNoteComponent = loadable(
  () => import("../../components/DebitNote/index")
);

const DebitNote = () => {
  return (
    <>
      <div className={tw`flex items-center justify-between`}>
        <h1 className={tw`font-semibold text-2xl leading-8`}>Debit Note</h1>
      </div>
      <DebitNoteComponent />
    </>
  );
};

export default DebitNote;
